/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  GetSiteResponseData,
  GetSiteResponseDataFromJSON,
  GetSiteResponseDataFromJSONTyped,
  GetSiteResponseDataToJSON
} from './GetSiteResponseData'

/**
 *
 * @export
 * @interface ShareToContactSiteResponse
 */
export interface ShareToContactSiteResponse {
  /**
   *
   * @type {number}
   * @memberof ShareToContactSiteResponse
   */
  status?: number
  /**
   *
   * @type {GetSiteResponseData}
   * @memberof ShareToContactSiteResponse
   */
  data?: GetSiteResponseData
}

export function ShareToContactSiteResponseFromJSON(json: any): ShareToContactSiteResponse {
  return ShareToContactSiteResponseFromJSONTyped(json, false)
}

export function ShareToContactSiteResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ShareToContactSiteResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : GetSiteResponseDataFromJSON(json['data'])
  }
}

export function ShareToContactSiteResponseToJSON(value?: ShareToContactSiteResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: GetSiteResponseDataToJSON(value.data)
  }
}
